<div class="configure-information-datatable-wrapper">

  <div class="configure-information-header">
    <h4>{{ sidebarItemData.title | translate }}</h4>
    <div class="submit-actions">
      <button 
        class="btn primary-button float-end" 
        (click)="addNewRow()"
        translate="{{'buttons.add_new_row' }}"
      ></button>
    </div>
  </div>

  <div *ngIf="loading">
    <app-dynamic-table
      [columns]="columns"
      [rows]="tableData"
      [dataTableMinWidth]="768"
      [useExternalApi]="true"
      [totalCount]="totalCount"
      [dataTableState]="configDataTableState"
      [filters]="filters"
      (dataTableStateEvent)="getDataTableState($event)"
      (currentEditedRowEvent)="getCurrentEditedRow($event)"
      (actionButtonEvent)="actionButton($event)"
      (changeInputFieldEvent)="changeInputField($event)"
      (enableEditEvent)="enableEdit($event)"
      (onSelectSearchEvent)="onSelectSearch($event)"
      (onClearEvent)="onClear($event)"
      ></app-dynamic-table>
  </div>

</div>
